import { ExperiencePerformanceTypes } from '@atlassian/ufo-experimental/experience-types';
import {
	type ExperienceData,
	type PageLoadExperienceData,
} from '@atlassian/ufo-experimental/types';

import { type SSRConfig } from '../../../../../types';
import { isInitialPageLoad } from '../../../../utils/is-initial-page-load';
import { customTimings } from './custom';
import { ssrTimings } from './ssr';

export const appTimings = (
	data: ExperienceData,
	ssrConfig: SSRConfig | null,
): {
	'timings:app': any;
} | null => {
	const explicitTimings =
		(data.performanceType === ExperiencePerformanceTypes.PageLoad &&
			(data as PageLoadExperienceData).explicitTimings) ||
		null;

	const timings = customTimings(data);

	const ssr = isInitialPageLoad(data) ? ssrTimings(ssrConfig) : null;

	const timingsApp = (explicitTimings || timings || ssr) && {
		...explicitTimings,
		...timings,
		...ssr,
	};

	if (!timingsApp || Object.keys(timingsApp).length === 0) {
		return null;
	}

	return { 'timings:app': timingsApp };
};
